<template>
  <div class="the-layout-mobile">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'TheLayoutMobile'
}
</script>

<style lang="scss" scoped>
.the-layout-mobile{
  width: 100%;
  height: 100%;
}
</style>
